<template>
  <div class="inventory">
    <div class="content">
      <p class="page-title">{{ $route.name }}</p>
      <button @click="newForm()" class="btn fixed_btn">New Form</button>

      <div class="card">
        <p class="title">Your Forms</p>
        <div class="table-holder">
          <table>
            <thead>
              <tr>
                <th>Title</th>
                <th>Questions</th>
                <!-- <th>Created At</th> -->
                <th>Details</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(item, i) in forms">
                <tr :key="i" :class="{ grey: i % 2 }">
                  <td data-label="Title">
                    <div class="img-text">{{ item.title }}</div>
                  </td>
                  <td data-label="Questions">{{ item.questions.length }}</td>
                  <!-- <td data-label="Created At">
                    {{ item.created_at | format_date_time }}
                  </td>-->

                  <td class="edit" data-label="Edit">
                    <img
                      @click="handleEdit(item)"
                      class="action clickable"
                      src="@/assets/img/edit.svg"
                    />
                  </td>
                  <td class="edit" data-label="Delete">
                    <img
                      @click="handleDelete(item)"
                      class="action clickable"
                      src="@/assets/img/delete.svg"
                    />
                  </td>
                  <div class="mobile-editor">
                    <div class="edit-btn">
                      <img
                        @click="handleEdit(item)"
                        class="action clickable"
                        src="@/assets/img/edit.svg"
                      />
                    </div>
                    <div class="edit-btn">
                      <img
                        @click="handleDelete(item)"
                        class="action clickable"
                        src="@/assets/img/delete.svg"
                      />
                    </div>
                  </div>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <div class="pagination">
          <div
            class="action prev"
            :class="{ inactive: !pagination.previous_doc }"
            @click="moveToPage(0)"
          >
            <img src="@/assets/img/dark_arr.svg" />
            <img src="@/assets/img/dark_arr.svg" />
          </div>
          <div
            class="action prev"
            :class="{ inactive: !pagination.previous_doc }"
            @click="moveToPage(0)"
          >
            <img src="@/assets/img/dark_arr.svg" />
          </div>
          <!-- <div class="pages">
            <div class='action page active' >
              {{((pagination.current_page-1)*pagination.page_size)+1}}-{{pagination.current_page*pagination.page_size}} of {{usage[source+'s']}}
            </div>
          </div>-->
          <div
            class="action next"
            :class="{ inactive: !pagination.next_doc }"
            @click="moveToPage(1)"
          >
            <img src="@/assets/img/dark_arr.svg" />
          </div>
          <div
            class="action next"
            :class="{ inactive: !pagination.next_doc }"
            @click="moveToPage()"
          >
            <img src="@/assets/img/dark_arr.svg" />
            <img src="@/assets/img/dark_arr.svg" />
          </div>
        </div>
      </div>
      <div class="card">
        <p class="title">Download QR code</p>
        <p>
          Download a QR code for users to scan and then register and fill out
          the survey on their phone.
        </p>
        <div class="inputs">
          <div class="input">
            <label>Form</label>
            <v-select
              :options="forms"
              label="title"
              :clearable="false"
              :reduce="(d) => 'form_' + d.title + '_' + d.id"
              v-model="form_name"
              @input="grabId"
            >
              <template v-slot:option="option">
                <div>{{ option.title }}</div>
              </template>
            </v-select>
          </div>
          <div class="input">
            <label>Location</label>
            <v-select
              :options="locations"
              label="name"
              :clearable="false"
              :reduce="(d) => 'location_' + d.name + '_' + d.id"
              v-model="location_name"
              @input="grabId"
            >
              <template v-slot:option="option">
                <div>
                  {{
                    `${option.id} - ${option.address_1}, ${option.city}, ${option.state}`
                  }}
                </div>
              </template>
            </v-select>
          </div>
        </div>
        <div class="btns left">
          <button
            :class="{ disabled: !form || !location }"
            @click="getQR()"
            class="btn round-btn"
          >
            Download QR code
          </button>
          <div ref="qr" class="qr">
            <vue-qr
              :size="1000"
              :text="
                'https://covid19-mobileregistration.web.app/' +
                  user_doc.id +
                  '/' +
                  form +
                  '/' +
                  location
              "
            ></vue-qr>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Register from "@/components/Register";
import firebase from "firebase";
import Swal from "sweetalert2";
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const auth = fb.default.auth;
import VueQr from "vue-qr";

export default {
  name: "loginregister",
  components: {
    register: Register,
    VueQr,
  },
  data() {
    return {
      details: null,
      forms: [],
      usage: {
        forms: 0,
        visitors: 0,
        employees: 0,
        locations: 0,
        departments: 0,
      },
      source: "forms",
      pagination: {
        previous_doc: null,
        next_doc: null,
        page_size: 10,
        current_page: 1,
      },
      location: null,
      form: null,
      form_name: null,
      locations: null,
      location_name: null,
    };
  },
  firestore() {
    return {
      locations: db
        .collection("user")
        .doc(this.user_doc.id)
        .collection("locations"),
    };
  },
  async created() {
    await this.$bind("usage", db.collection("usage").doc(this.user_doc.id));
    return this.moveToPage(0);
  },
  methods: {
    grabId(data) {
      data = data.split("_");
      this[data[0]] = data[2];
      this[data[0] + "_name"] = data[1];
    },
    getQR() {
      var link = document.createElement("a");
      link.download = this.form + ".png";
      link.href = this.$refs.qr.children[0].src;
      link.click();
    },
    moveToPage(page) {
      let pagination = this.pagination;
      let ref = db
        .collection("user")
        .doc(this.user_doc.id)
        .collection(this.source);
      if (this.filter_values) {
        for (const key in this.filter_values) {
          if (this.filter_values.hasOwnProperty(key) && this.filter_values) {
            const element = this.filter_values[key];
            if (element) {
              ref = ref.where(`${key}.id`, "==", element.id);
            }
          }
        }
      }
      if (page === -1) {
        //Previous Page
        ref = ref
          .limit(pagination.page_size)
          .orderBy("title", "desc")
          .startAfter(pagination.previous_doc);
      } else if (page === 1) {
        //Next Page
        ref = ref
          .limit(pagination.page_size)
          .orderBy("title")
          .startAfter(pagination.next_doc);
      } else if (page === 0) {
        //First page
        ref = ref.limit(pagination.page_size).orderBy("title");
      } else {
        //Last page
        let total = this.usage[this.source + "s"];
        let last_full_page = Math.floor(total / pagination.page_size);
        let limit = total - last_full_page * pagination.page_size;
        ref = ref.limit(limit || pagination.page_size).orderBy("title", "desc");
      }

      ref.get().then((query) => {
        let docs = query.docs;

        if (page === -1 || page === undefined) {
          // counting down
          docs.reverse();
        }
        if (query.size === 0 && page !== 0) {
          if (page === 1) {
            this.pagination.next_doc = null;
          } else if (page === -1) {
            this.pagination.previous_doc = null;
          }
        } else {
          let forms = docs.map((d) => Object.assign({ id: d.id }, d.data()));
          this.pagination.previous_doc = docs[0];
          this.pagination.next_doc = docs[docs.length - 1];
          if (page === 0) {
            this.pagination.previous_doc = null;
            this.pagination.current_page = 1;
            if (query.size < pagination.page_size) {
              this.pagination.next_doc = null;
            }
          } else if (page === undefined) {
            let total = this.usage[this.source];
            let last_full_page = Math.ceil(total / pagination.page_size);
            this.pagination.next_doc = null;
            this.pagination.current_page = last_full_page;
          } else {
            this.pagination.current_page += page;
            if (query.size < pagination.page_size) {
              this.pagination[page === -1 ? "previous_doc" : "next_doc"] = null;
            }
          }
          this.forms = forms;
        }
        this.pagination = Object.assign({}, this.pagination);
      });
      return true;
    },
    handleEdit(item) {
      this.$router.push("form/" + item.id);
    },
    async handleDelete(item) {
      let result = await Swal.fire({
        title: `Delete "${item.title}"?`,
        text: `You won't be able to undo this!`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Delete",
      });
      if (result.value) {
        return db
          .collection("user")
          .doc(this.user_doc.id)
          .collection(this.source)
          .doc(item.id)
          .delete()
          .then(() => {
            Swal.fire(
              "Deleted!",
              "Your file has been deleted.",
              "success"
            ).then(() => {
              this.moveToPage(0);
            });
          })
          .catch((err) => {
            console.warn(err);
            Swal.fire(
              "Unsuccessful!",
              `An error occurred: ${err.message}.`,
              "error"
            );
          });
      }
    },
    newForm() {
      let id = db.collection("form").doc().id;
      this.goTo("/form/" + id);
    },
  },
};
</script>

<style lang="scss">
.stats {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .card {
    width: 49%;
    position: relative;
    padding-top: 70px;
    transition: box-shadow 0.3s;
    cursor: pointer;
    &:hover {
      box-shadow: 0 0 15px rgba(128, 128, 128, 0.8);
    }
    img {
      position: absolute;
      z-index: 0;
      opacity: 0.1;
      height: 80%;
      right: 10%;
      top: 50%;
      transform: translateY(-50%);
    }
    .stat {
      font-size: 80px;
      color: #49c6d4;
      font-weight: 500;
      margin: 0;
      span {
        display: block;
        font-size: 16px;
        color: #132628;
        font-weight: 500;
        margin-top: -10px;
      }
    }
  }
}
.disabled {
  opacity: 0.3;
  pointer-events: none;
}

.qr {
  position: fixed;
  z-index: -2;
  opacity: 0;
}
</style>
